import PropTypes from 'prop-types';

export const optionPropTypes = {
  admin: PropTypes.bool,
  disabled: PropTypes.bool,
  index: PropTypes.number,
  liquidContext: PropTypes.object,
  option: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  overridden: PropTypes.bool,
  overrideMode: PropTypes.bool,
  readOnlyOption: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.string]),

  onChange: PropTypes.func.isRequired,
  onOptionChange: PropTypes.func,
  onOptionDelete: PropTypes.func,
  onOverrideDefault: PropTypes.func,
  onUseDefault: PropTypes.func
};
